import {FILTERS_GROUPS_IDS} from '../../common/filtersGroups.js'
import {FILTER_NAMES} from '../ads.js'

export const SECOND_HAND_VEHICLES_LISTING_SECTION_FILTERS_GROUPS = {
  [FILTERS_GROUPS_IDS.MAKE_GROUP_ID]: {
    icon: 'moto',
    label: 'FILTERS_GROUPS.MAKE.LABEL.DEFAULT',
    filters: [FILTER_NAMES.MAKE, FILTER_NAMES.MODEL]
  },
  [FILTERS_GROUPS_IDS.PRICE_GROUP_ID]: {
    icon: 'tag',
    label: 'FILTERS_GROUPS.PRICE.LABEL.DEFAULT',
    filters: [FILTER_NAMES.PRICE, FILTER_NAMES.HAS_PRICE_DROP]
  },
  [FILTERS_GROUPS_IDS.LOCATION_GROUP_ID]: {
    icon: 'poi',
    label: 'FILTERS_GROUPS.LOCATION.LABEL.DEFAULT',
    filters: [FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID, FILTER_NAMES.ONLY_PENINSULA]
  },
  [FILTERS_GROUPS_IDS.SELLER_GROUP_ID]: {
    icon: 'shieldCheck',
    label: 'FILTERS_GROUPS.SELLER.LABEL.DEFAULT',
    filters: [FILTER_NAMES.SELLER_TYPE, FILTER_NAMES.HAS_PHOTO]
  },
  [FILTERS_GROUPS_IDS.YEAR_GROUP_ID]: {
    icon: 'calendar',
    label: 'FILTERS_GROUPS.YEAR.LABEL.DEFAULT',
    filters: [FILTER_NAMES.YEAR]
  },
  [FILTERS_GROUPS_IDS.KMS_GROUP_ID]: {
    icon: 'kmOdometer',
    label: 'FILTERS_GROUPS.KMS.LABEL.DEFAULT',
    filters: [FILTER_NAMES.KMS]
  },
  [FILTERS_GROUPS_IDS.BODY_TYPE_GROUP_ID]: {
    icon: 'motoSize',
    label: 'FILTERS_GROUPS.BODY_TYPE.LABEL.DEFAULT',
    filters: [FILTER_NAMES.BODY_TYPE_CATEGORY]
  },
  [FILTERS_GROUPS_IDS.MOTOR_GROUP_ID]: {
    icon: 'carEngine',
    label: 'FILTERS_GROUPS.ENGINE.LABEL.DEFAULT',
    filters: [FILTER_NAMES.FUEL_TYPE, FILTER_NAMES.LITRES, FILTER_NAMES.HP]
  }
}
